module.exports = __webpack_public_path__ + "img/pc-who-are-we-pic3.55f74e2b.png";